import { TextField, InputAdornment } from '@mui/material';
import { Component } from 'react';

const formatThousands = (raw) => {
    if (raw === '' || raw === null || raw === undefined) return '';
    return Number(raw).toLocaleString('pt-BR');
};

const unformat = (raw) => raw.replace(/\D/g, ''); // remove tudo que não é dígito

const TYPE_CONFIG = {
    integer: {
        inputType: 'number',
        inputProps: { min: 0, step: 1 },
    },
    monetary: {
        inputType: 'text',
        adornment: { startAdornment: <InputAdornment position="start">R$</InputAdornment> },
        format: formatThousands,
        unformat: unformat,
    },
    time: {
        inputType: 'number',
        inputProps: { min: 0, step: 1 },
        adornment: { endAdornment: <InputAdornment position="end">h</InputAdornment> },
    },
    percentage: {
        inputType: 'number',
        inputProps: { min: 0, max: 100, step: 1 },
        adornment: { endAdornment: <InputAdornment position="end">%</InputAdornment> },
    },
};

const parseInteger = (raw) => raw === '' ? '' : String(parseInt(raw, 10));

export default class MetaInvInput extends Component {
    render() {
        const { type = 'integer', label, value, error, sx, required, onChange, props } = this.props;
        const config = TYPE_CONFIG[type] || TYPE_CONFIG.integer;

        const displayValue = config.format ? config.format(value) : value;

        const handleChange = (e) => {
            if (!onChange) return;
            const raw = config.unformat ? config.unformat(e.target.value) : e.target.value;
            onChange(parseInteger(raw));
        };

        return (
            <TextField
                {...props}
                type={config.inputType}
                inputProps={config.inputProps}
                {...(config.adornment ? { InputProps: config.adornment } : {})}
                sx={sx}
                error={error === true}
                helperText={error === true ? "Informe o valor da meta" : null}
                size="small"
                variant="outlined"
                name="maxcount"
                label={label + (required ? '*' : '')}
                value={displayValue}
                onChange={handleChange} />
        );
    }
}